import * as agent from "./agent";

import {
  ASYNC_START,
  ASYNC_END,
  LOGIN,
  LOGOUT,
  REGISTER
} from "./constants/actionTypes";



const promiseMiddleware = store => next => action => {
    if (!isPromise(action.payload)) {
        next(action);
        return;
    }

    store.dispatch({type: ASYNC_START, subtype: action.type});
    action.payload.then(
        res => {
            console.log("RESULT", res);
            action.payload = res;
            store.dispatch({type: ASYNC_END, promise: action.payload});
            store.dispatch(action);
        },
        error => {
            console.error("promiseMiddleware", error);
            action.error = true;
            action.payload = error.response.body;
            store.dispatch({type: ASYNC_END, promise: action.payload});
            store.dispatch(action);
        }
    );
};

const localStorageMiddleware = store => next => action => {
    switch (action.type) {
    case REGISTER:
    case LOGIN:
        if (!action.error) {
            const {token} = action.payload.user;
            window.localStorage.setItem("jwt", token);
            agent.setToken(token);
        }
        break;
    case LOGOUT:
        window.localStorage.setItem("jwt", "");
        agent.setToken(null);
        break;
    default:
        // nothing
    }

    next(action);
};

function isPromise(v) {
  return v && typeof v.then === 'function';
}


export { promiseMiddleware, localStorageMiddleware }



// WEBPACK FOOTER //
// ./src/middleware.js